<div style="width: 100%;">

    <div fxLayoutAlign="center center" style="width: 100%;">

        <div class="p-20" style="width: 100%;">

            <div>

                <ng-container *ngFor="let pregunta of control; let i = index; let last = last; let first = first;">
                    <div>
                        <mat-icon aria-hidden="false" class="mr-20" matTooltip="" style="display:none">menu</mat-icon>

                        <mat-expansion-panel class="mb-20 accent-50">
                            <mat-expansion-panel-header [ngClass]=" pregunta.updated == false ? 'defaultQuestion': 'editQuestion' ">
                                <mat-panel-title>
                                    {{ pregunta.orden }}
                                </mat-panel-title>
                                <mat-panel-description>
                                    {{'CERTIFICAR.CONTROL.CONFIGURE_QUESTION' | translate}}
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <p>{{'CERTIFICAR.DEMOGRAFICOS.QUESTION' | translate}}</p>
                            <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20">


                                <mat-form-field class="input" appearance="outline" fxFlex="100">
                                    <mat-label>{{'CERTIFICAR.DEMOGRAFICOS.QUESTION' | translate}}</mat-label>
                                    <textarea  matInput required [value]="pregunta.pregunta" (blur)="onBlurPregunta($event,pregunta);" [disabled]="pasoCompleto || instituto == 'MX'"></textarea>
                                    <mat-error>Error, complete la pregunta</mat-error>
                                </mat-form-field>

                                <!-- <button [disabled]="pasoCompleto" *ngIf="pregunta.obligatorio != 1" mat-icon-button aria-label="borraPreg" (click)="deletePregunta($event,pregunta)" matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.TOOLTIP.REMOVE' | translate}}">
                              <mat-icon class="s-40">delete_forever</mat-icon>
                            </button> -->

                            </div>

                        </mat-expansion-panel>

                    </div>
                </ng-container>
                <!-- <div   fxLayout="row" fxLayoutAlign="center center" style="padding:20px 0px;">
                    <h2 class="pr-20">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.ACCIONES.ADD' | translate}}</h2>
                    <button [disabled]="pasoCompleto" mat-fab color="primary" aria-label="agregaPreg" (click)="agregaPregunta()">
                <mat-icon>add</mat-icon>
              </button>
                </div> -->
            </div>
            <hr>
        </div>
    </div>
</div>
